import React from 'react';
import { Emblem } from './Emblem';
export function Footer() {
  return <footer className="bg-paper pt-20 pb-10 border-t border-gold/25" data-id="element-254">
      <div className="container-custom" data-id="element-255">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10 md:gap-12 mb-14" data-id="element-256">
          <div className="col-span-2 lg:col-span-2 lg:pr-12" data-id="element-257">
            <a href="/" className="inline-flex mb-5" data-id="element-258">
              <img src="https://cdn.magicpatterns.com/uploads/h2GZL1vXJEV8VZaWTvuTy7/new-sinclairs-logo-v1-jpg.webp" alt="Sinclairs Jewellers of Distinction · Established 1947" className="h-16 w-auto object-contain" data-id="element-259" />
            </a>
            <p className="signature text-3xl text-gold-dark leading-none mb-4" data-id="element-260">
              Heritage. Craftsmanship. Trust.
            </p>
            <p className="text-sm text-secondary leading-relaxed max-w-sm" data-id="element-261">
              Perth's trusted family jeweller. Designed, made and cared for on
              our bench in Ardross — by the same family since 1947.
            </p>
          </div>

          <div data-id="element-262">
            <h4 className="brand-mark text-[0.65rem] uppercase text-primary mb-5" data-id="element-263">
              Services
            </h4>
            <ul className="space-y-3" data-id="element-264">
              {['Engagement Rings', 'Custom Jewellery', 'Repairs & Restoration', 'Heirloom Remodelling', 'Diamonds', 'Valuations'].map(item => <li key={item} data-id="element-265">
                  <a href="#" className="text-sm text-secondary hover:text-gold-dark transition-colors" data-id="element-266">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-267">
            <h4 className="brand-mark text-[0.65rem] uppercase text-primary mb-5" data-id="element-268">
              Visit
            </h4>
            <address className="not-italic text-sm text-secondary space-y-3 leading-relaxed" data-id="element-269">
              <p data-id="element-270">
                Shop 5&amp;6 Riseley Square
                <br data-id="element-271" />
                7–9 Riseley Street
                <br data-id="element-272" />
                Ardross WA 6153
              </p>
              <p className="pt-2 border-t border-gold/15" data-id="element-273">
                Mon–Fri: 9 – 4:30
                <br data-id="element-274" />
                Saturday: 9 – 1<br data-id="element-275" />
                Sunday: Closed
              </p>
            </address>
          </div>

          <div data-id="element-276">
            <h4 className="brand-mark text-[0.65rem] uppercase text-primary mb-5" data-id="element-277">
              Contact
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-278">
              <li data-id="element-279">
                <a href="tel:0893162321" className="text-primary font-medium hover:text-gold-dark transition-colors" data-id="element-280">
                  08 9316 2321
                </a>
              </li>
              <li data-id="element-281">
                <a href="#consultation" className="text-secondary hover:text-gold-dark transition-colors" data-id="element-282">
                  Book a consultation
                </a>
              </li>
              <li data-id="element-283">
                <a href="mailto:hello@sinclairs.com.au" className="text-secondary hover:text-gold-dark transition-colors" data-id="element-284">
                  Send a message
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex items-center justify-center mb-8" data-id="element-285">
          <Emblem size={28} className="text-gold/50" data-id="element-286" />
        </div>

        <div className="border-t border-gold/20 pt-6 pb-6 mb-6" data-id="element-287">
          <p className="brand-mark text-[0.65rem] uppercase text-muted mb-2 text-center md:text-left" data-id="element-288">
            Proudly serving south of the river
          </p>
          <p className="text-xs text-secondary leading-relaxed text-center md:text-left" data-id="element-289">
            Ardross · Applecross · Mount Pleasant · Booragoon · South Perth ·
            Como · Manning · Salter Point · Bicton · Attadale · Melville ·
            Kensington · Victoria Park · Canning Bridge
          </p>
        </div>

        <div className="pt-6 border-t border-gold/15 flex flex-col md:flex-row items-center justify-between gap-3" data-id="element-290">
          <p className="text-xs text-muted" data-id="element-291">
            © 2026 Sinclairs Jewellers · Established 1947 · Ardross WA
          </p>
          <div className="flex gap-6 text-xs text-muted" data-id="element-292">
            <a href="#" className="hover:text-gold-dark transition-colors" data-id="element-293">
              Privacy
            </a>
            <a href="#" className="hover:text-gold-dark transition-colors" data-id="element-294">
              Terms
            </a>
            <a href="#" className="hover:text-gold-dark transition-colors" data-id="element-295">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}